
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface DuplicateCollectionResponseModel {
	readonly collectionId: string;
}

export const useOperationDuplicate = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<DuplicateCollectionResponseModel>, string> = collectionId => {
		return http<DuplicateCollectionResponseModel, undefined>({
			method: "POST",
			url: `/collection/${collectionId}/operation/duplicate`,
			body: undefined
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
		}
	});
};
